import {getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {
    className, children, value,
    _parent, _isCloned
} = self.get();

const active = _parent._isActive(value);
const classNameObj = {
    'k-carousel-item': true,
    [className]: className,
    'k-active': active,
    'k-cloned': _isCloned,
};
const isSlide = _parent._isSlide();

    return h(Animate, {
        'className': _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)),
        'a:show': function() {try {return (isSlide || active )} catch(e) {_e(e)}}.call($this),
        'a:disabled': function() {try {return (isSlide )} catch(e) {_e(e)}}.call($this),
        'a:transition': 'k-fade',
        'a:continuity': function() {try {return (false )} catch(e) {_e(e)}}.call($this),
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this),
        'children': (_blocks['children'] = function(parent) {
            return function() {try {return (children )} catch(e) {_e(e)}}.call($this);
        }) && (__blocks['children'] = function(parent) {
            var args = arguments;
            return blocks['children'] ? blocks['children'].apply($this, [function() {
                return _blocks['children'].apply($this, args);
            }].concat(__slice.call(args, 1))) : _blocks['children'].apply($this, args);
        }) && __blocks['children'].apply($this, [__noop]),
        '_context': $this
    })
}